var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5625 19.0625C8.85645 19.0625 9.11279 19.0933 9.33154 19.1548C9.55029 19.2163 9.75537 19.3052 9.94678 19.4214C10.1382 19.5376 10.3193 19.6777 10.4902 19.8418C10.6611 20.0059 10.8457 20.1836 11.0439 20.375H2V4.625H3.3125V19.0625H8.5625ZM8.5625 3.3125C9.02051 3.3125 9.47168 3.36719 9.91602 3.47656C10.3604 3.58594 10.7842 3.75684 11.1875 3.98926V18.7036C10.8184 18.396 10.4082 18.1602 9.95703 17.9961C9.50586 17.832 9.04102 17.75 8.5625 17.75H4.625V3.3125H8.5625ZM21.6875 4.625V20.375H12.6436C12.835 20.1836 13.0161 20.0059 13.187 19.8418C13.3579 19.6777 13.5391 19.541 13.7305 19.4316C13.9219 19.3223 14.127 19.2334 14.3457 19.165C14.5645 19.0967 14.8242 19.0625 15.125 19.0625H20.375V4.625H21.6875ZM15.125 17.75C14.6465 17.75 14.1816 17.832 13.7305 17.9961C13.2793 18.1602 12.8691 18.396 12.5 18.7036V3.98926C12.9033 3.76367 13.3271 3.59619 13.7715 3.48682C14.2158 3.37744 14.667 3.31934 15.125 3.3125H19.0625V17.75H15.125Z",
    fill: "#40499D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.a7a2fa38d297a352712c7366bb59f60b.svg";
export { ForwardRef as ReactComponent };